import getShiftedOffset from "../getShiftedOffset";
import updateLoadingItemState from "../updateLoadingItemState";
import { ITEM_STATE_PLACEHOLDER } from "../../../constants";

const mergeNewItemsWithItemsState = ({
  items,
  offset,
  limit,
  offsetId,
  incomingItems
}) => {
  const shiftedOffset = getShiftedOffset({ items, offsetId, offset });

  return [
    ...items.slice(0, shiftedOffset),
    ...updateLoadingItemState(
      items.slice(shiftedOffset, offset),
      ITEM_STATE_PLACEHOLDER
    ),
    ...incomingItems,
    ...items.slice(offset + limit)
  ];
};

export default mergeNewItemsWithItemsState;
